module.exports = __webpack_public_path__ + "img/Accountor-13-lowres.53060d8a.jpg";